import { Context, Schema } from "effect";
import { HttpApiError, HttpApiMiddleware, HttpApiSecurity } from "effect/http-api";
import { UUID } from "./uuid.js";

export class SessionUser extends Schema.Class<SessionUser>("SessionUser")({
  iat: Schema.DateTimeUtcFromMillis,
  exp: Schema.DateTimeUtcFromMillis,
  email: Schema.String,
  clientId: UUID,
  userId: UUID,
  accessToken: Schema.String,
}) {}

export class CurrentUser extends Context.Service<CurrentUser, SessionUser>()(
  "@bloodline/CurrentUser"
) {}

export class Authorization extends HttpApiMiddleware.Service<
  Authorization,
  { provides: CurrentUser }
>()("Authorization", {
  error: HttpApiError.UnauthorizedNoContent,
  security: {
    // Additional security definitions can be added here.
    // They will attempt to be resolved in the order they are defined.
    bloodlineAccessCookie: HttpApiSecurity.apiKey({
      in: "cookie",
      key: "bloodline.auth.access_token",
    }),
    httpSecureCookie: HttpApiSecurity.apiKey({
      in: "cookie",
      key: "next-auth.session-token",
    }),
    bearerToken: HttpApiSecurity.bearer,
  },
}) {}
